import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import CmsImage from 'src/components/images/CmsImage';
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import Image from "src/components/images/Image";
import { CSSPosterMissing, CSSPosterMissingMovieTitle, CSSPosterSizer, CSSPosterWrapper, type SPosterMissingProps } from 'src/components/posterrow/CSSPoster';
import KinoklubbPosterBanner from 'src/kinoklubbposterbanner/KinoklubbPosterBanner';
import { type ImageVersion, type Movie, type StreamingContent, type WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import { isMovie, isStreamingContent, isWatchableContent } from "src/lib/movieinfo/typeGuards";
import styled, { css } from 'src/lib/styles/css';
import { IFilmomtale, isFilmomtale } from 'src/lib/types/Filmomtale';
import classNames from "classnames";

//#region [Props]
type PosterImageProps = {
    film: IFilmomtale | Movie | StreamingContent | WatchableContent;
    isKinoklubb?: boolean;
    showMovieTitleIfPosterIsMissing?: boolean;
    filmUrl: string;
    hasPoster: boolean;
    sizes?: string;
    width?: number;
    posterMissingText?: string;
    hideKinoklubbBanner?: boolean;

};
//#endregion

//#region [Component]
export default function PosterImage({ film, isKinoklubb = false, hasPoster, showMovieTitleIfPosterIsMissing = false, filmUrl, sizes, width, posterMissingText = "Plakat mangler", hideKinoklubbBanner = false }: PosterImageProps) {
    const isUnoptimized = !!width ? true : false;
    return <SPosterWrapper className="PosterImage" $isPosterMissing={!hasPoster} $showMovieTitle={showMovieTitleIfPosterIsMissing} data-postermissingtext={posterMissingText} data-movietitle={film.title}>
        <SFilmwebLink to={filmUrl}>
            {hasPoster && <>
                {isFilmomtale(film) && <SCMSPosterImage
                    alt={`Plakat for '${film.title}'`}
                    image={film?.mainPosterV2 ?? film.postersV2?.[0]}
                    sizes={sizes}
                    width={width}
                    unoptimized={isUnoptimized}
                    isPosterAspect />}
                {isMovie(film) && <SCMSPosterForUrl
                    imageUrl={film.sanityImagePosterUrl!}
                    alt={`Plakat for '${film.title}'`}
                    sizes={sizes}
                    width={width}
                    unoptimized={isUnoptimized}
                    isPosterAspect
                    applyAspectRatio
                />}
                {isStreamingContent(film) && hasPoster && <>
                    {film.sanityImagePosterUrl && <SCMSPosterForUrl
                        imageUrl={film.sanityImagePosterUrl}
                        alt={`Plakat for '${film.title}'`}
                        sizes={sizes}
                        width={width}
                        unoptimized={isUnoptimized}
                        isPosterAspect

                    />}
                    {!film.sanityImagePosterUrl && <SPosterForUrl
                        image={film.imagesPoster as ImageVersion[]}
                        alt={`Plakat for '${film.title}'`}
                        unoptimized={isUnoptimized}
                        sizes={sizes}
                    />}
                </>}
                {isWatchableContent(film) && hasPoster && <>
                    {film.sanityImagePosterUrl && <SCMSPosterForUrl
                        imageUrl={film.sanityImagePosterUrl}
                        alt={`Plakat for '${film.title}'`}
                        sizes={sizes}
                        width={width}
                        unoptimized={isUnoptimized}
                        isPosterAspect
                    />}
                    {!film.sanityImagePosterUrl && <SPosterForUrl
                        image={film.imagesPosterStreaming as ImageVersion[]}
                        alt={`Plakat for '${film.title}'`}
                        unoptimized={isUnoptimized}
                        sizes={sizes}
                    />}
                </>}
            </>}
            {isKinoklubb && !hideKinoklubbBanner && <KinoklubbPosterBanner />}
        </SFilmwebLink>
    </SPosterWrapper>;
}
//#endregion

//#region [Styles]
const SPosterWrapper = styled.div<SPosterMissingProps>`
	${CSSPosterWrapper}

	${props => props.$isPosterMissing ? CSSPosterMissing : ""}

	${props => props.$isPosterMissing && props.$showMovieTitle ? CSSPosterMissingMovieTitle : ""}
`;

const SFilmwebLink = styled(FilmwebLink)`
	${CSSPosterSizer}
	display: flex;
	justify-content: center;
	align-items: flex-start;
`;

const CSSImageStaticHeightImage = css`
	width: 100%;
	height: auto;
`;

const SCMSPosterImage = styled(CmsImage)`
    ${CSSImageStaticHeightImage}
`;

const SCMSPosterForUrl = styled(CmsImageForUrl)`
    ${CSSImageStaticHeightImage}
`;

const SPosterForUrl = styled(Image)`
    ${CSSImageStaticHeightImage}
`;
//#endregion